import React from "react";

const Title = () => {
  return <>Missions</>;
};

export default Title;
